import { type CSSObject, Stack, Typography, styled } from '@mui/material';

import { Button, Section } from '@rumblefish/ui/Rumblefish23Theme';

import chequered from '../../../public/webp/fromPNG/chequered.webp';

export const StyledSection = styled(Section)(() => ({
  position: 'relative',
}));

export const StyledStack = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(9, 0, 9, 0),
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(8),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0, 0, 5, 0),
    gap: theme.spacing(4),
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0, 0, 9, 0),
    gap: theme.spacing(4),
  },
}));

export const StyledFrame = styled(Stack)(({ theme }) => ({
  width: '100%',

  background: theme.palette.invertedColors?.PLUS_8,
  borderRadius: theme.spacing(4),
  gap: theme.spacing(6),

  padding: `${theme.utils.fluidSize({
    minSize: 32,
    maxSize: 120,
    minBp: 960,
  })} ${theme.utils.fluidSize({ minSize: 32, maxSize: 280, minBp: 960 })}`,
  [theme.breakpoints.down('md')]: {
    backgroundImage: `none`,
    padding: '32px 32px',
  },
  [theme.breakpoints.down('sm')]: {
    backgroundImage: `none`,
    padding: '24px 16px',
  },
  [theme.breakpoints.up('xl')]: {
    padding: '120px 280px',
  },

  backgroundImage: ` url(${chequered})`,
}));

export const StyledHeadlineWrapper = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
}));

export const StyledHeadline = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
}));

export const StyledInfoSection = styled(Stack)<{
  reverse?: boolean;
  bottomMargin?: boolean;
}>(({ theme, reverse, bottomMargin }) => ({
  flexDirection: reverse ? 'row-reverse' : 'row',
  marginBottom: bottomMargin ? theme.spacing(8) : 0,
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const StyledColumnInfoWrapper = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(6),
  flex: 1,
}));

export const StyledImage = styled('img')<{ reverse?: boolean }>(
  ({ theme, reverse }) => ({
    position: 'absolute',
    top: 0,
    left: reverse ? '' : 0,
    right: reverse ? 0 : '',
    width: `calc(100% + ${theme.utils.fluidSize({
      minSize: 32,
      maxSize: 280,
      minBp: 960,
    })})`,

    [theme.breakpoints.up('xl')]: {
      width: '160%',
    },
    [theme.breakpoints.down('xl')]: {
      top: '20%',
    },
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      width: '100%',
    },
  })
);

export const StyledInfoWrapper = styled(Stack)(({ theme }) => ({
  position: 'relative',
  flex: 1,
  alignItems: 'center',
  paddingBottom: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(6, 0, 0, 0),
  },
}));

export const StyledSingleInfoWrapper = styled(Stack)<{ reverse?: boolean }>(
  ({ theme, reverse }) => ({
    gap: theme.spacing(1),
    padding: reverse ? theme.spacing(0, 0, 0, 2) : theme.spacing(0, 2, 0, 0),
    [theme.breakpoints.down('md')]: {
      border: 0,
      padding: 0,
    },
    borderRight: reverse
      ? '0px'
      : `1px solid ${theme.palette.greyBackgroundColor?.SURFACE + '10'}`,
    borderLeft: !reverse
      ? '0px'
      : `1px solid ${theme.palette.greyBackgroundColor?.SURFACE + '10'}`,
  })
);

export const StyledInfoTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.PRIMARY,
}));

export const StyledInfoDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.TETRIARY,
  lineHeight: '28px !important',
}));

export const StyledButtonWrapper = styled(Stack)({
  display: 'flex',
  alignItems: 'flex-start',
});

export const StyledButton = styled(Button)(({ theme }) => ({
  boxShadow: `0px 0px 6px 4px ${theme.palette.cyanColors?.PLUS_2} !important`,

  '.MuiStack-root': {
    backgroundColor: 'transparent !important',
    border: '1px solid white',
    boxShadow: `0px 0px 6px 4px ${theme.palette.cyanColors?.PLUS_2} inset !important`,
  },
}));
